import { render, staticRenderFns } from "./ContactCallCard.vue?vue&type=template&id=a554b3b6&"
import script from "./ContactCallCard.vue?vue&type=script&lang=js&"
export * from "./ContactCallCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports